<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog2" persistent max-width="600">
      <v-card>
        <!-- <v-card-title class="headline">Use Google's location service?</v-card-title> -->
        <!-- <v-card-text>{{url}}</v-card-text> -->
      

        <img v-bind:src="url" class="white--text"  height="300px"    >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click.native="close">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>

  export default {
   
    props: {
        dialog2: {
        default: false
      },
      url:null
    },
    methods: {
        close() {
        this.$emit('update:dialog2', false)
      }
    }
  }

</script>


// WEBPACK FOOTER //
// src/components/PicModal.vue